export default __webpack_public_path__ + "static/selfapp-536-mobile-c4ac263fb51c156968d73e38e6720bbe.jpg";